/**
 * Shared sortable table header cell.
 * Extracted from ReportsList (Feb 2026) so any list surface can adopt the
 * same click-to-toggle, icon-swap, aria-sort behaviour without drift.
 *
 * Usage:
 *   const [sort, setSort] = useState({ key: 'submitted_at', dir: 'desc' });
 *   const onSortClick = (k) => setSort(s =>
 *     s.key === k ? { key: k, dir: s.dir === 'asc' ? 'desc' : 'asc' }
 *                 : { key: k, dir: 'desc' });
 *   <SortHeader label="Submitted" sortKey="submitted_at"
 *               sortState={sort} onSortClick={onSortClick}
 *               testIdPrefix="qa-sort" />
 */
import React from 'react';
import { TableHead } from '@/components/ui/table';
import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';

export function SortHeader({
  label, sortKey, sortState, onSortClick,
  className = '',
  testIdPrefix = 'reports-sort',
}) {
  const active = sortState?.key === sortKey;
  const Icon = !active ? ArrowUpDown : (sortState.dir === 'asc' ? ArrowUp : ArrowDown);
  return (
    <TableHead
      className={`cursor-pointer select-none group ${className}`}
      onClick={() => onSortClick(sortKey)}
      data-testid={`${testIdPrefix}-${sortKey}`}
      aria-sort={active ? (sortState.dir === 'asc' ? 'ascending' : 'descending') : 'none'}
    >
      <span className="inline-flex items-center gap-1">
        {label}
        <Icon
          className={`w-3 h-3 ${active ? 'text-[#0F172A]' : 'text-[#94A3B8] opacity-0 group-hover:opacity-100'}`}
          strokeWidth={2.5}
        />
      </span>
    </TableHead>
  );
}

export default SortHeader;
